export const GoogleMapApiConfig = 'AIzaSyDw77S2Yd399xzBqtjaQaHJO-1bK2PFxwI';